var _ellipse, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _path2, _path3, _circle2, _polygon, _path4, _path5, _path6, _path7, _polygon2, _path8, _path9, _polygon3, _path0, _circle3, _path1, _rect9, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adb70ced-db85-4cc8-a8af-ce8a9a5cd296",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 699.63911,
    height: 722.95455,
    viewBox: "0 0 699.63911 722.95455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.81956,
    cy: 715.95455,
    rx: 122,
    ry: 7,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M697.73719,798.66475c15.3-17.40808,87.34931-103.09155,36.14-117.21722-38.46148-10.60926-42.74646,47.75982-41.45556,86.93029-6.15869-26.3905-18.11127-57.21881-39.11084-43.61682-30.26447,19.603,26.444,62.98432,41.2572,73.63385.24323,2.16553.40369,3.36908.40369,3.36908s.6076-.66253,1.69073-1.88183c.84619.59253,1.31684.91076,1.31684.91076S697.90046,800.02522,697.73719,798.66475Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.29861,
    y: 8.10882,
    width: 699.3405,
    height: 447.88877,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.29609,
    y: 64.28525,
    width: 659.34554,
    height: 365.21521,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 494.83962,
    y: 101.71096,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 494.83962,
    y: 206.928,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 494.83962,
    y: 312.14504,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 63.00086,
    y: 101.71096,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 63.00086,
    y: 206.928,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.00086,
    y: 312.14504,
    width: 142.09725,
    height: 79.9297,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 357.9141,
    cy: 120.16244,
    r: 28.89501,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M711.07142,116.77445l9.65385-8.09677a11.40955,11.40955,0,0,0,.85192-16.69189l0,0a11.40953,11.40953,0,0,0-18.80886,3.79237l-4.60741,11.7745-36.88724,63.3231-18.751,51.33474,15.06229,18.13623,20.288-62.70831Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M505.73245,116.77445l-9.65385-8.09677a11.40953,11.40953,0,0,1-.85192-16.69189l0,0a11.40954,11.40954,0,0,1,18.80887,3.79237l4.60741,11.7745,36.88724,63.3231,20.59538,51.94953-16.90665,17.52144L538.931,177.6384Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#a0616a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.14367,
    cy: 91.26743,
    r: 14.7549,
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "360.373 552.973 347.155 552.051 347.77 371.918 380.354 379.91 360.373 552.973",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M595.72672,686.279h0a12.84952,12.84952,0,0,1-11.84467-8.60615c-2.87516-8.44647-1.38921-16.48314,3.61713-24.189l-1.63561-11.44931a12.737,12.737,0,0,1,2.99757-10.159l8.47464-9.74584V634.4254c6.20311-5.42539,10.02752-5.62157,15.36968-1.22957l-4.91829,25.20628,1.20084,13.80965A12.95036,12.95036,0,0,1,595.72672,686.279Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M631.76385,276.00438l-51.64213-1.22958c7.31756-7.11319,17.79731-34.38824,15.98447-42.42032h25.20628C618.28671,240.62065,624.143,268.69971,631.76385,276.00438Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M645.28917,370.68163l-71.31533-20.90277,2.45915-30.73937-6.14787-31.35415c.62711-3.40155-15.60475-45.41751-14.7549-48.5682,3.39531-12.58754,12.28786-10.848,18.751-19.98059,1.0493-1.48271,9.24025,8.946,14.5371,15.99756.62868,1.08622,1.06066,1.82249,1.35833,2.3215a18.35753,18.35753,0,0,1,2.47294,11.169l-.00643.068h0c-2.90228,10.04634,3.76608,5.92733,14.22178,6.10159h0c8.87038.14784,16.90666,7.17625,16.90666-1.69535h0c-.01459-.50285-.03683-1.02814-.06053-1.568a24.74207,24.74207,0,0,1,3.11508-13.00986c.13693-.24863-.51668.78961,2.829-4.91425,5.99972-8.48385,14.26166-19.75683,14.71183-18.15894,1.89513,6.72672,11.64734,12.37811,15.06229,24.2841.52563,1.83257-2.64179,12.95635-2.45915,14.7549,1.36924,13.48358-1.22957,20.90277-2.45915,31.35415A264.848,264.848,0,0,0,645.28917,370.68163Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#f56565"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M635.45258,475.81026l-40.576-12.29574-.61479-36.88724-31.96894-61.47874,12.29575-20.288,70.08576,18.44362C649.4561,393.94812,644.18568,433.36776,635.45258,475.81026Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "366.214 338.105 344.081 338.105 302.891 280.315 317.646 268.019 366.214 338.105",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M626.84555,426.01249h-36.7759a43.558,43.558,0,0,1-24.47666-7.48c-16.12041-10.89677-21.28137-32.3205-12.52192-49.69517h0l73.77448,3.68872Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M594.668,384.57323l-32.37511-.98107q-.182-.461-.34541-.92655c-4.3059-12.26268,2.16889-25.59357,14.1487-30.63324,1.20622-.50743,2.43086-.97627,3.68269-1.40839a19.338,19.338,0,0,1,25.70475,17.92467,48.7505,48.7505,0,0,1-.45875,7.3656A10.123,10.123,0,0,1,594.668,384.57323Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#a0616a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "326.867 394.665 313.957 394.665 312.112 290.151 348.385 289.536 326.867 394.665",
    fill: "#a0616a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M562.52821,529.11262h0a12.84949,12.84949,0,0,1-11.84466-8.60615c-2.87516-8.44647-1.38921-16.48314,3.61713-24.189L552.665,484.86812a12.737,12.737,0,0,1,2.99757-10.159l8.47464-9.74584V477.259c6.20311-5.42539,10.02752-5.62157,15.36969-1.22957l-4.9183,25.20628,1.20084,13.80965A12.95035,12.95035,0,0,1,562.52821,529.11262Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 358.83628,
    cy: 127.84728,
    r: 25.20628,
    fill: "#a0616a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M631.14907,205.30383c0,12.90243-11.68907-5.53308-24.5915-5.53308s-22.13234,18.43551-22.13234,5.53308a23.36192,23.36192,0,0,1,46.72384,0Z",
    transform: "translate(-250.18044 -88.52272)",
    fill: "#2f2e41"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 7.71237,
    width: 699.3405,
    height: 29.71054,
    fill: "#f56565"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.07849,
    cy: 22.90197,
    r: 5.50662,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.98024,
    cy: 22.90197,
    r: 5.50662,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.882,
    cy: 22.90197,
    r: 5.50662,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyDevice);
export default __webpack_public_path__ + "static/media/loyalty_device.5b3270c93777550fde869b1a77310399.svg";
export { ForwardRef as ReactComponent };